export const environment = {
    production: false,
    apiUrl: 'http://uatnew.gibl.in/php-services/investment-plans-api/service.php'
};
